import type { IProductEntity } from '~/entities';

import { ETrackerActions, useTracker } from '~/features/clickstream-sdk';

export function useProductCardTracker() {
  const { track } = useTracker();

  function trackProductCartClick(product: IProductEntity, additionalPayload?: any) {
    return track({
      action: ETrackerActions.CLICK,
      block: 'productListing',
      element: 'item',
      ...getProductCardTrackerPayload(product),
      ...additionalPayload,
    });
  }

  function trackProductCartView(product: IProductEntity, additionalPayload?: any) {
    return track({
      action: ETrackerActions.VIEW,
      block: 'productListing',
      element: 'item',
      ...getProductCardTrackerPayload(product),
      ...additionalPayload,
    });
  }

  function getProductCardTrackerPayload(product: IProductEntity) {
    return {
      product_id: product.id,
      in_stock: product.availableAmount,
      old_price: product.fullPrice,
      price: product.sellPrice,
      wishlist_toggle: product.isFavorite,
      rating_value: product.rating,
      rev_num: product.feedbackQuantity,
      shop_id: product.shop?.id,
      badges: product.badges?.map((it) => it.text).join(';'),
      badges_id: product.badges?.map((it) => it.id).join(';'),
      clickable_badges: product.badges?.map((it) => !!it.link).join(';'),
      discount_percent: getDiscountPercent(product),
      product_name: product.title,
    };
  }

  function getDiscountPercent(product: IProductEntity) {
    if (typeof product.discountPercent !== 'undefined') return product.discountPercent;
    if (product.fullPrice === product.sellPrice) return undefined;

    return Math.round(((product.fullPrice - product.sellPrice) / product.fullPrice) * 100);
  }

  return {
    trackProductCartClick,
    trackProductCartView,
  };
}
